export default "__VITE_ASSET__D$1oqm4o__"